import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const Topbar = ({ onMenuClick }) => {
    const { isDark, toggleTheme } = useTheme();

    const styles = {
        topbar: {
            position: 'fixed',
            top: 0,
            left: '280px',
            right: 0,
            height: '64px',
            background: isDark ? '#1e1e1e' : '#ffffff',
            borderBottom: `1px solid ${isDark ? '#333' : '#e5e7eb'}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 1.5rem',
            zIndex: 998,
            transition: 'all 0.3s ease',
        },
        topbarMobile: {
            left: 0,
        },
        left: {
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
        },
        menuButton: {
            display: 'none',
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            padding: '0.5rem',
        },
        title: {
            fontSize: '1.25rem',
            fontWeight: 600,
            color: isDark ? '#ffffff' : '#1f2937',
        },
        right: {
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
        },
        themeToggle: {
            background: isDark ? '#2d2d2d' : '#f3f4f6',
            border: `1px solid ${isDark ? '#444' : '#e5e7eb'}`,
            borderRadius: '50px',
            padding: '0.5rem 1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            cursor: 'pointer',
            transition: 'all 0.2s',
        },
        themeIcon: {
            fontSize: '1.2rem',
        },
        themeText: {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: isDark ? '#fff' : '#374151',
        },
    };

    return (
        <>
            <div style={{ ...styles.topbar, ...(window.innerWidth < 1024 ? styles.topbarMobile : {}) }}>
                <div style={styles.left}>
                    <button
                        onClick={onMenuClick}
                        style={styles.menuButton}
                        className="mobile-menu-button"
                    >
                        ☰
                    </button>
                    <div style={styles.title}>Dashboard</div>
                </div>

                <div style={styles.right}>
                    <button
                        onClick={toggleTheme}
                        style={styles.themeToggle}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <span style={styles.themeIcon}>{isDark ? '☀️' : '🌙'}</span>
                        <span style={styles.themeText}>{isDark ? 'Light' : 'Dark'}</span>
                    </button>
                </div>
            </div>

            <style>{`
        @media (max-width: 1023px) {
          .mobile-menu-button {
            display: block !important;
          }
        }
      `}</style>
        </>
    );
};

export default Topbar;
